/**
 * Created by Jerker Nord on 2019-03-20.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TimelineMax} from "gsap";
import {IconState, IIconView} from "../featureIcons/IIconView";
import {ThorGameShaker} from "../gameshake/ThorGameShaker";
import {ThorReelSymbol} from "../symbols/ThorReelSymbol";
import {ThorGameConfig} from "../ThorGameConfig";
import {ThorGameModuleConfig} from "../ThorGameModuleConfig";
import {ThorSoundConfig} from "../ThorSoundConfig";

export class ThorMjolnirtimeView extends BaseView {

    private _layer:ScalableLayer;
    private _thorMjolnirtime:TimelineSprite;
    private _thorMjolnirtimeLightning:TimelineSprite;
    private _iconFrameglowSelection:TimelineSprite;
    private _iconSelected:TimelineSprite;
    private _mjolnirtimeContainer:PIXI.Container;
    private _iconSelectContainer:PIXI.Container;
    private _loopingMjolnirAnimationTL:TimelineMax;
    private _loopingMjolnirLightningAnimationTL:TimelineMax;
    private _iconGlowFramePositionsLandscape:PIXI.Point[] = [new PIXI.Point(0, 0), new PIXI.Point(0, 108), new PIXI.Point(0, 217), new PIXI.Point(0, 327)];
    private _iconGlowFramePositionsPortrait:PIXI.Point[] = [new PIXI.Point(-510, -99), new PIXI.Point(-380, -99), new PIXI.Point(-250, -99), new PIXI.Point(-120, -99)];
    private _iconSelectedCounter:number;
    private _orientation:string;
    private _isFreeSpin:boolean = false;
    private _selectedIcon:number;
    private _iconSelectAnimation:TimelineLite;
    private _iconSelectedAnimation:TimelineLite;
    private _stopLoopingMjolnirtimeAnimationTL:TimelineLite;
    private _mjolnirtimeAnimationTL:TimelineLite;
    private _iconViews:IIconView[] = [];
    private _previouslyEnabledRandomIcon:number = 0;

    private static MJOLNIRTIME_ANIMATION_OFFSET_XPOS:number = -15;
    private static MJOLNIRTIME_ANIMATION_OFFSET_YPOS:number = -7;
    private static ICON_SELECT_CONTAINER_OFFSET:PIXI.Point = new PIXI.Point(1156, 59);

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.MJOLNIRTIME.name);
        this._layer.addChild(this);

        this._mjolnirtimeContainer = new PIXI.Container();
        this._mjolnirtimeContainer.visible = false;
        this._mjolnirtimeContainer.name = "_mjolnirtimeContainer";
        this.addChild(this._mjolnirtimeContainer);

        this._iconSelectContainer = new PIXI.Container();
        this._iconSelectContainer.name = "_iconSelectContainer";
        this._iconSelectContainer.position = ThorMjolnirtimeView.ICON_SELECT_CONTAINER_OFFSET;
        this.addChild(this._iconSelectContainer);

    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
    }

    protected initAnimations():void {
        this._thorMjolnirtime = new TimelineSprite(GameResources.getTextures("mjolnirtimeAnimation"));
        this._thorMjolnirtime.anchor.set(0.5, 0.5);
        this._mjolnirtimeContainer.addChild(this._thorMjolnirtime);

        this._thorMjolnirtimeLightning = new TimelineSprite(GameResources.getTextures("mjolnirtimeLightningAnimation"));
        this._thorMjolnirtimeLightning.anchor.set(0.5, 0.5);
        this._thorMjolnirtimeLightning.blendMode = PIXI.BLEND_MODES.ADD;
        this._mjolnirtimeContainer.addChild(this._thorMjolnirtimeLightning);

        this._iconFrameglowSelection = new TimelineSprite(GameResources.getTextures("iconFrameGlow"));
        this._iconFrameglowSelection.anchor.set(0.5, 0.5);
        this._iconFrameglowSelection.position = this._iconGlowFramePositionsLandscape[0];
        this._iconFrameglowSelection.blendMode = PIXI.BLEND_MODES.ADD;
        this._iconFrameglowSelection.alpha = 0;
        this._iconSelectContainer.addChild(this._iconFrameglowSelection);

        this._iconSelected = new TimelineSprite(GameResources.getTextures("iconSelected"));
        this._iconSelected.anchor.set(0.5, 0.5);
        this._iconSelected.alpha = 0;
        this._iconSelected.blendMode = PIXI.BLEND_MODES.ADD;
        this._iconSelectContainer.addChild(this._iconSelected);

        this._loopingMjolnirAnimationTL = new TimelineMax({repeat : -1, paused : true});
        this._loopingMjolnirAnimationTL.add(this._thorMjolnirtime.getAnimationAutoShowHide(true, true, [12, 16]));
        this._loopingMjolnirAnimationTL.add(this._thorMjolnirtime.getAnimationAutoShowHide(true, true, [15, 11]));

        this._loopingMjolnirLightningAnimationTL = new TimelineMax({repeat : -1, paused : true});
        this._loopingMjolnirLightningAnimationTL.add(this._thorMjolnirtimeLightning.getAnimationAutoShowHide(true, true, [8, 19]));
        this._loopingMjolnirLightningAnimationTL.add(this._thorMjolnirtimeLightning.getAnimationAutoShowHide(true, true, [18, 7]));

        this._iconViews.push(ThorGameModuleConfig.thorMultiplierIconView);
        this._iconViews.push(ThorGameModuleConfig.thorRandomWildIconView);
        this._iconViews.push(ThorGameModuleConfig.thorReelWildIconView);
        this._iconViews.push(ThorGameModuleConfig.thorExtraFSIconView);
    }

    public abort():void {
        if(this._mjolnirtimeAnimationTL && this._mjolnirtimeAnimationTL.isActive()) {
            this._mjolnirtimeAnimationTL.pause();
            this._mjolnirtimeAnimationTL.kill();
        }
        if(this._stopLoopingMjolnirtimeAnimationTL && this._stopLoopingMjolnirtimeAnimationTL.isActive()) {
            this._stopLoopingMjolnirtimeAnimationTL.pause();
            this._stopLoopingMjolnirtimeAnimationTL.kill();
        }

        (<ThorReelSymbol>Reels.getSymbol(this.getBonusSymbolReelPosition()[0], this.getBonusSymbolReelPosition()[1])!).setVisibility(true);
        this._mjolnirtimeContainer.visible = false;
        this._loopingMjolnirLightningAnimationTL.pause();
        this._loopingMjolnirLightningAnimationTL.kill();
        this._loopingMjolnirAnimationTL.pause();
        this._loopingMjolnirAnimationTL.kill();
        EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.STOP_GAME_SHAKING));
        if(this._iconSelectAnimation && this._iconSelectAnimation.isActive()) {
            this._iconSelectAnimation.pause();
            this._iconSelectAnimation.kill();
            this._iconFrameglowSelection.alpha = 0;
            this._iconFrameglowSelection.setFrame(0);
            this._iconSelected.alpha = 0;
            this._iconSelected.setFrame(0);
        }
        this.disableAllIcons();
        this._iconViews[this._selectedIcon].setState(IconState.enabled);

        this.getIconSelectedTL();
    }

    private getIconSelectedTL():TimelineLite {
        if(this._iconSelectedAnimation && this._iconSelectedAnimation.isActive()) {
            this._iconSelectedAnimation.pause();
            this._iconSelectedAnimation.kill();
            this._iconFrameglowSelection.alpha = 0;
            this._iconFrameglowSelection.setFrame(0);
            this._iconSelected.alpha = 0;
            this._iconSelected.setFrame(0);
        }
        this._iconSelectedAnimation = new TimelineLite();
        this._iconSelectedAnimation.add(() => this.setIconSelectedPosition(this._selectedIcon));
        this._iconSelectedAnimation.add(() => this._iconSelected.alpha = 1);
        this._iconSelectedAnimation.add([
            this._iconSelected.getAnimation(),
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_ICON_SELECTED),
            () => SlotGame.sound.stopEffect(ThorSoundConfig.instance.ELECTRIC_LOOP),
            () => this._iconFrameglowSelection.alpha = 0,
            () => this._iconFrameglowSelection.setFrame(0)
        ]);
        this._iconSelectedAnimation.add(() => this._iconSelected.alpha = 0);
        this._iconSelectedAnimation.add(() => this._iconSelected.setFrame(0));
        this._iconSelectedAnimation.add(() => this._iconViews[this._selectedIcon].setState(IconState.activated));
        return this._iconSelectedAnimation;
    }

    public getMjolnirtimeAnimation():TimelineLite {
        if(this._mjolnirtimeAnimationTL && this._mjolnirtimeAnimationTL.isActive()) {
            this._mjolnirtimeAnimationTL.pause();
            this._mjolnirtimeAnimationTL.kill();
        }
        this._mjolnirtimeAnimationTL = new TimelineLite();
        this._mjolnirtimeAnimationTL.add((() => this.setAnimationToBonusSymbolPosition()));
        this._mjolnirtimeAnimationTL.add((() => this._thorMjolnirtime.setFrame(0)));
        this._mjolnirtimeAnimationTL.add((() => this._thorMjolnirtimeLightning.setFrame(0)));
        this._mjolnirtimeAnimationTL.add(this._thorMjolnirtime.getAnimation([0 - 3]));
        this._mjolnirtimeAnimationTL.add([
            () => (<ThorReelSymbol>Reels.getSymbol(this.getBonusSymbolReelPosition()[0], this.getBonusSymbolReelPosition()[1])!).setVisibility(false),
            () => this._mjolnirtimeContainer.visible = true
        ]);
        this._mjolnirtimeAnimationTL.add([
            this._thorMjolnirtime.getAnimation([4, 11]),
            this._thorMjolnirtimeLightning.getAnimation([0, 7])
        ]);

        this._mjolnirtimeAnimationTL.add([
            this.getLoopingMjolnirAnimation().restart(),
            this.getLoopingMjolnirLightningAnimation().restart()
        ]);

        return this._mjolnirtimeAnimationTL;
    }

    private stopLoopingMjolnirAnimation():void {
        if(this._stopLoopingMjolnirtimeAnimationTL && this._stopLoopingMjolnirtimeAnimationTL.isActive()) {
            this._stopLoopingMjolnirtimeAnimationTL.pause();
            this._stopLoopingMjolnirtimeAnimationTL.kill();
        }
        this._stopLoopingMjolnirtimeAnimationTL = new TimelineLite({});
        this._stopLoopingMjolnirtimeAnimationTL.add(() => this._loopingMjolnirAnimationTL.pause());
        this._stopLoopingMjolnirtimeAnimationTL.add(() => this._loopingMjolnirAnimationTL.kill());
        this._stopLoopingMjolnirtimeAnimationTL.add([
            this._thorMjolnirtime.getAnimation([this.getCurrentFrameOfLoopingMjolnirAnimation(), 26])
        ]);
        this._stopLoopingMjolnirtimeAnimationTL.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_HAMMER_HIT));
        this._stopLoopingMjolnirtimeAnimationTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.START_GAME_SHAKING_BIG)));
        this._stopLoopingMjolnirtimeAnimationTL.add(() => this._loopingMjolnirLightningAnimationTL.pause());
        this._stopLoopingMjolnirtimeAnimationTL.add(() => this._loopingMjolnirLightningAnimationTL.kill());
        this._stopLoopingMjolnirtimeAnimationTL.add([
            this._thorMjolnirtime.getAnimation([27]),
            this._thorMjolnirtimeLightning.getAnimation([23])
        ]);
        this._stopLoopingMjolnirtimeAnimationTL.add((() => (<ThorReelSymbol>Reels.getSymbol(this.getBonusSymbolReelPosition()[0], this.getBonusSymbolReelPosition()[1])!).setVisibility(true)));
        this._stopLoopingMjolnirtimeAnimationTL.add((() => this._mjolnirtimeContainer.visible = false));
        this._stopLoopingMjolnirtimeAnimationTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.STOP_GAME_SHAKING)), "+=0.4");
    }

    private getCounter():number {
        return this._iconSelectedCounter;
    }

    private disableAllIcons():void {
        for(let i:number = 0; i < this._iconViews.length - 1; i++) {
            if(this._iconViews[i].getState() == IconState.enabled) {
                this._iconViews[i].setState(IconState.disabled);
            }
        }
        if(this._isFreeSpin == true && this._iconViews[this._iconViews.length - 1].getState() == IconState.enabled) {
            this._iconViews[this._iconViews.length - 1].setState(IconState.disabled);
        }
    }

    private enableRandomIcon():void {
        let enabledIcon:number;
        if(this._isFreeSpin == false) {
            enabledIcon = MathHelper.randomIntInRange(0, 2);
            // If it's the same as previous, pick a new one
            while(enabledIcon == this._previouslyEnabledRandomIcon) {
                enabledIcon = MathHelper.randomIntInRange(0, 2);
            }
        } else {
            enabledIcon = MathHelper.randomIntInRange(0, 3);
            // If it's the same as previous, pick a new one
            while(enabledIcon == this._previouslyEnabledRandomIcon) {
                enabledIcon = MathHelper.randomIntInRange(0, 3);
            }
        }

        this.enableIcon(enabledIcon);

    }

    private enableIcon(iconIndex:number) {
        this._previouslyEnabledRandomIcon = iconIndex;
        switch(iconIndex) {
            case 0:
                if(this._iconViews[0].getState() == IconState.disabled) {
                    this._iconViews[0].setState(IconState.enabled);
                }
                this.setFrameglowSelectionPosition(0);
                break;
            case 1:
                if(this._iconViews[1].getState() == IconState.disabled) {
                    this._iconViews[1].setState(IconState.enabled);
                }
                this.setFrameglowSelectionPosition(1);
                break;
            case 2:
                if(this._iconViews[2].getState() == IconState.disabled) {
                    this._iconViews[2].setState(IconState.enabled);
                }
                this.setFrameglowSelectionPosition(2);
                break;
            case 3:
                if(this._iconViews[3].getState() == IconState.disabled) {
                    this._iconViews[3].setState(IconState.enabled);
                }
                this.setFrameglowSelectionPosition(3);
                break;
            default:
                break;
        }
    }

    public setFrameglowSelectionPosition(icon:number):void {
        if(this._orientation == Orientation.PORTRAIT) {
            this._iconFrameglowSelection.scale.set(1.2, 1.2);
            this._iconFrameglowSelection.position = this._iconGlowFramePositionsPortrait[icon];
            if(!this._iconViews[icon].fsIconIsVisible) {
                this._iconFrameglowSelection.position.x += 130;
            }


        } else {
            this._iconFrameglowSelection.scale.set(1, 1);
            this._iconFrameglowSelection.position = this._iconGlowFramePositionsLandscape[icon];
        }
    }

    public setIconSelectedPosition(icon:number):void {
        if(this._orientation == Orientation.PORTRAIT) {
            this._iconSelected.scale.set(1.2, 1.2);
            this._iconSelected.position = this._iconGlowFramePositionsPortrait[icon];

            if(!this._iconViews[icon].fsIconIsVisible) {
                this._iconSelected.position.x += 130;
            }
        } else {
            this._iconSelected.scale.set(1, 1);
            this._iconSelected.position = this._iconGlowFramePositionsLandscape[icon];
        }
    }

    public getIconSelectAnimation(selectedIcon:number, isFreeSpin:boolean):TimelineLite {
        this._isFreeSpin = isFreeSpin;
        this._selectedIcon = selectedIcon;

        if(this._iconSelectAnimation && this._iconSelectAnimation.isActive()) {
            this._iconSelectAnimation.pause();
            this._iconSelectAnimation.kill();
            this._iconFrameglowSelection.alpha = 0;
            this._iconFrameglowSelection.setFrame(0);
            this._iconSelected.alpha = 0;
            this._iconSelected.setFrame(0);
        }

        //Small delay here so Thor has time to lift his hammer
        this._iconSelectAnimation = new TimelineLite({delay : 0.3});
        this._iconSelectAnimation.add(() => this._iconFrameglowSelection.alpha = 1);
        this._iconSelectAnimation.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.ELECTRIC_LOOP, -1));
        this._iconSelectAnimation.add([
            this.getIconFrameGlowSelectionTL()
        ]);
        this._iconSelectAnimation.add(() => this.stopLoopingMjolnirAnimation());
        this._iconSelectAnimation.add(() => this.setFrameglowSelectionPosition(this._selectedIcon));
        this._iconSelectAnimation.add(() => this._iconViews[this._selectedIcon].setState(IconState.enabled));
        this._iconSelectAnimation.add(this._iconFrameglowSelection.getAnimation([0]));
        this._iconSelectAnimation.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_ICON_SELECT));
        this._iconSelectAnimation.add(this.getIconSelectedTL());

        return this._iconSelectAnimation;
    }

    private getIconFrameGlowSelectionTL():TimelineLite {
        let iconFrameGlowSelectionTL:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < MathHelper.randomIntInRange(7, 9); i++) {
            iconFrameGlowSelectionTL.add(() => this.enableRandomIcon());
            iconFrameGlowSelectionTL.add(this._iconFrameglowSelection.getAnimation([0, 10]));
            iconFrameGlowSelectionTL.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_ICON_SELECT));
            iconFrameGlowSelectionTL.add(() => this.disableAllIcons());
        }
        return iconFrameGlowSelectionTL;
    }

    private getLoopingMjolnirLightningAnimation():TimelineLite {
        return this._loopingMjolnirLightningAnimationTL;
    }

    private getLoopingMjolnirAnimation():TimelineLite {
        return this._loopingMjolnirAnimationTL;
    }

    private getCurrentFrameOfLoopingMjolnirAnimation():number {
        return this._thorMjolnirtime.currentFrame;
    }

    private getCurrentFrameOfLoopingMjolnirLightningAnimation():number {
        return this._thorMjolnirtimeLightning.currentFrame;
    }

    private setAnimationToBonusSymbolPosition():void {
        let symbolPosition:[number, number] = this.getBonusSymbolPosition(this.getBonusSymbolReelPosition());

        this._mjolnirtimeContainer.position = new PIXI.Point(symbolPosition![0] + ThorMjolnirtimeView.MJOLNIRTIME_ANIMATION_OFFSET_XPOS, symbolPosition![1] + ThorMjolnirtimeView.MJOLNIRTIME_ANIMATION_OFFSET_YPOS);
    }

    private getBonusSymbolReelPosition():[number, number] {
        let tempSymbol:ThorReelSymbol;
        let symbolReelPosition:[number, number] = [0, 0];

        for(let i:number = 0; i < 4; i++) {
            tempSymbol = <ThorReelSymbol>Reels.getSymbol(4, i)!;
            if(tempSymbol.symName == "B") {
                symbolReelPosition = [4, i];
                break;
            }
        }
        return symbolReelPosition;
    }

    private getBonusSymbolPosition(reelAndPosition:[number, number]):[number, number] {
        return Helper.getSymbolPositions(reelAndPosition[0], reelAndPosition[1]);
    }
}